import React from "react";
import { Link } from "react-router-dom";

export default function Retail(props) {
  return (
    <>
      <div>
        {" "}
        <div id="smooth-wrapper">
          <div id="smooth-content">
            <div class="breadcrumb-section mb-120">
              <div class="container mb-70">
                <div class="row">
                  <div class="col-xl-8 col-lg-10">
                    <div class="breadcrumb-content">
                      <ul class="breadcrumb-list">
                        <li>
                          <a href="service-details.html#">Home</a>
                        </li>
                        <li>
                          <svg
                            width="24"
                            height="6"
                            viewBox="0 0 24 6"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M-3.26633e-05 2.88672L2.88672 5.77347L5.77347 2.88672L2.88672 -3.26633e-05L-3.26633e-05 2.88672ZM23.7735 2.88672L20.8867 -3.26633e-05L18 2.88672L20.8867 5.77347L23.7735 2.88672ZM2.88672 2.88672V3.38672H20.8867V2.88672V2.38672H2.88672V2.88672Z" />
                          </svg>
                          Retail
                        </li>
                      </ul>
                      <h1>Retail Industry</h1>
                      <div class="para">
                        <div class="icon">
                          <svg
                            width="6"
                            height="49"
                            viewBox="0 0 6 49"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M2.88672 -3.26633e-05L-3.26633e-05 2.88672L2.88672 5.77347L5.77347 2.88672L2.88672 -3.26633e-05ZM2.88672 48.7735L5.77347 45.8867L2.88672 43L-3.26633e-05 45.8867L2.88672 48.7735ZM2.88672 2.88672H2.38672L2.38672 45.8867H2.88672H3.38672L3.38672 2.88672H2.88672Z" />
                          </svg>
                        </div>
                        <p>
                          {" "}
                          Retailers are rising to the challenge of meeting
                          ever-growing customer expectations for seamless, 24/7
                          service. To deliver the consistent and personalised
                          experiences shoppers demand across every touchpoint,
                          many are transforming legacy systems and embracing
                          digital integration.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


              <div class="home1-testimonial-section mb-120">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12 mb-60">
                            <div class="section-title three">
                                <span>Retail</span>
                                <h2 class="text-anim">Delivering personalised retail experiences</h2>
                                <div class="right-content">
                                    <ul class="review-area">
                                        <li>
                                            <a href="case-study1.html#" class="rating-area">
                                              
                                              
                                            </a>
                                        </li>
                                        <li>
                                         
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="testimonial-slider-area">
                        <div class="swiper home1-testimonial-slider">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide">
                                    <div class="testimonial-card">
                                        <div class="row gy-4">
                                            <div class="col-lg-8 d-flex align-items-center justify-content-center">
                                                <div class="testimonial-content-wrap">
                                                    <div class="testimonial-content">
                                                        
                                                        <h3></h3>
                                                        <p>From storefront to supply chain, Insight Wide ERP unifies your retail operations, delivering real-time insights across financials, inventory, logistics, and sales channels. With end-to-end visibility and data-driven decision-making, you can deliver seamless customer experiences, optimise stock levels, and bring products to market faster and more efficiently.

</p>
                                                    </div>
                                                   
                                                    <svg class="quote" width="90" height="66" viewBox="0 0 90 66"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M2.14042 65.4859L2.13985 65.486C0.465777 65.6958 -0.145829 63.4059 1.3666 62.74L1.36702 62.7398C10.6535 58.6405 15.5326 53.3624 16.1668 47.9767L16.1669 47.9766C16.6365 43.9852 14.4641 40.3342 11.5096 39.6286L11.5095 39.6286C8.26933 38.8558 5.52035 36.4554 3.57183 33.1359C1.62485 29.819 0.502964 25.6234 0.502964 21.3522C0.502964 15.8231 2.71671 10.5197 6.65849 6.60885C10.6004 2.69787 15.9476 0.5 21.524 0.5C27.6271 0.5 32.8687 2.99571 36.5916 7.3391C40.3187 11.6874 42.5449 17.9146 42.545 25.3967C42.4673 47.107 26.0325 62.5195 2.14042 65.4859ZM49.0954 65.4859L49.0948 65.486C47.4208 65.6958 46.8091 63.4059 48.3216 62.74L48.322 62.7398C57.6084 58.6405 62.4875 53.3624 63.1218 47.9767L63.1218 47.9766C63.5915 43.9852 61.4191 40.3342 58.4646 39.6286L58.4644 39.6286C55.2243 38.8558 52.4753 36.4554 50.5268 33.1359C48.5798 29.819 47.4579 25.6234 47.4579 21.3522C47.4579 15.8231 49.6717 10.5197 53.6135 6.60885C57.5554 2.69787 62.9026 0.5 68.479 0.5C74.5821 0.5 79.8236 2.99571 83.5466 7.3391C87.2735 11.6872 89.4996 17.914 89.5 25.3957C89.4229 47.1065 72.9879 62.5194 49.0954 65.4859Z" />
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-7">
                                                <div class="testimonial-img-wrap">
                                                    <div class="testimonial-img">
                                                        <img src="assets/retail.png" alt=""/>
                                                       
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                               
                              
                            </div>
                        </div>
                        <div class="swiper-pagination1 testimonial-pagi"></div>
                    </div>
                </div>
            </div>

            <div class="service-details-page mb-120">
              <div class="container">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="service-details-content-wrap">
                      <div class="row mb-70">
                        <div class="col-lg-12">
                          <div class="service-details-title mb-20">
                            <h2>Key Features:</h2>
                          </div>
                          <div class="key-features-area">
                            <ul class="key-features-list">
                              <li>Omnichannel</li>
                              <li class="two">Personalization</li>
                              <li class="three">Availability</li>
                              <li class="two">Integration</li>
                              <li class="four">Security Reliability </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-80">
                        <div class="col-lg-12">
                          <div class="service-details-title mb-40">
                            <h2>Why Choose Us:</h2>
                          </div>
                          <div class="why-choose-area-wrap">
                            <div class="row g-0">
                              <div class="col-lg-6">
                                <div class="why-choose-area">
                                  <ul class="why-choose-list">
                                    <li>
                                      <div class="icon">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M6.0655 11.4289L8.23374 13.7583C9.57941 12.3163 15.5608 5.27243 19 2C15.4382 6.991 12.3418 12.1977 9.55693 17.4299C9.15734 18.1804 7.73243 18.1932 7.31286 17.4488C5.98626 15.0959 4.56 12.7577 3 10.4859C4.12158 10.3195 5.31763 10.5969 6.06527 11.4289H6.0655Z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                      <div class="content">
                                        <p>
                                          <span>Unified Omnichannel Experience–</span>{" "}
                                          Bridge the gap between physical stores and digital storefronts. Our solutions provide a "Single Source of Truth," ensuring consistent pricing, inventory, and customer data across every touchpoint, 24/7.
                                        </p>
                                      </div>
                                    </li>
                                    <li>
                                      <div class="icon">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M6.0655 11.4289L8.23374 13.7583C9.57941 12.3163 15.5608 5.27243 19 2C15.4382 6.991 12.3418 12.1977 9.55693 17.4299C9.15734 18.1804 7.73243 18.1932 7.31286 17.4488C5.98626 15.0959 4.56 12.7577 3 10.4859C4.12158 10.3195 5.31763 10.5969 6.06527 11.4289H6.0655Z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                      <div class="content">
                                        <p>
                                          <span>
                                          Data-Driven Personalization –
                                          </span>{" "}
                                         Turn shopper behavior into actionable insights. Leverage advanced analytics to deliver the personalized experiences modern customers demand, increasing loyalty and maximizing every sales opportunity.
                                        </p>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div class="col-lg-6">
                                <div class="why-choose-area">
                                  <ul class="why-choose-list">
                                    <li class="justify-content-lg-end">
                                      <div class="icon">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M6.0655 11.4289L8.23374 13.7583C9.57941 12.3163 15.5608 5.27243 19 2C15.4382 6.991 12.3418 12.1977 9.55693 17.4299C9.15734 18.1804 7.73243 18.1932 7.31286 17.4488C5.98626 15.0959 4.56 12.7577 3 10.4859C4.12158 10.3195 5.31763 10.5969 6.06527 11.4289H6.0655Z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                      <div class="content">
                                        <p>
                                          <span>
                                         Seamless Legacy Integration –
                                          </span>{" "}
                                          Modernize without the downtime. We specialize in transforming outdated legacy systems into agile, digitally integrated platforms that streamline operations and eliminate manual bottlenecks.
                                        </p>
                                      </div>
                                    </li>
                                    <li class="justify-content-lg-end">
                                      <div class="icon">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g>
                                            <path
                                              fill-rule="evenodd"
                                              clip-rule="evenodd"
                                              d="M6.0655 11.4289L8.23374 13.7583C9.57941 12.3163 15.5608 5.27243 19 2C15.4382 6.991 12.3418 12.1977 9.55693 17.4299C9.15734 18.1804 7.73243 18.1932 7.31286 17.4488C5.98626 15.0959 4.56 12.7577 3 10.4859C4.12158 10.3195 5.31763 10.5969 6.06527 11.4289H6.0655Z"
                                            />
                                          </g>
                                        </svg>
                                      </div>
                                      <div class="content">
                                        <p>
                                          <span>
                                          Inventory & Fulfillment Precision –
                                          </span>{" "}
                                         Never miss a sale due to stockouts. Gain real-time visibility into your entire supply chain, from warehouse to checkout, enabling faster fulfillment and smarter stock management.
                                        </p>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                           <div class="home3-process-section mb-120">
                <div class="container">
                    <div class="row gy-3 mb-60 justify-content-between">
                        <div class="col-lg-6">
                            <div class="section-title home3-section-title three">
                                <span>Process</span>
                                <h2 class="text-anim">How We Work
                                    With You</h2>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-between gy-4">
                        <div class="col-lg-6">
                            <div class="process-content-wrap">
                                <div class="process-content">
                                    <div class="icon">
                                        <svg width="9" height="87" viewBox="0 0 9 87"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M4.33008 1.19209e-05L-4.91142e-05 4.33014L4.33008 8.66027L8.66021 4.33014L4.33008 1.19209e-05ZM4.33008 86.6603L8.66021 82.3301L4.33008 78L-4.91142e-05 82.3301L4.33008 86.6603ZM4.33008 4.33014H3.58008L3.58008 82.3301H4.33008H5.08008L5.08008 4.33014H4.33008Z" />
                                        </svg>
                                    </div>
                                    <p>An integrated ERP system like Insight Wide provides end-to-end visibility across your supply chain, along with real-time, actionable insights. This empowers you to make informed decisions that accelerate growth, improve operational efficiency, and maintain compliance with industry standards.</p>
                                </div>
                                <Link class="primary-btn2 transparent" to="/contact">
                                    <span class="icon">
                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1 9L9 1M9 1C7.22222 1.33333 3.33333 2 1 1M9 1C8.66667 2.66667 8 6.33333 9 9"
                                                stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </span>
                                    <span class="content">Let’s Work Together</span>
                                    <span class="icon two">
                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1 9L9 1M9 1C7.22222 1.33333 3.33333 2 1 1M9 1C8.66667 2.66667 8 6.33333 9 9"
                                                stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </span>
                                </Link>
                                <div class="process-img-area">
                                    <img src="assets/image/digital-marketing/process-img.png" alt="" class="light"/>
                                    <img src="assets/image/digital-marketing/process-img-dark.png" alt="" class="dark"/>
                                    <img src="assets/image/digital-marketing/process-progress-gif.gif" alt=""
                                        class="process-gif"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-5 col-lg-6">
                            <ul class="process-list">
                                <li class="single-process">
                                    <div class="step-no"><span>01</span>
                                        <div class="icon">
                                            <svg width="6" height="95" viewBox="0 0 6 95"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M3.38672 0.5C3.38672 0.223858 3.16286 0 2.88672 0C2.61058 0 2.38672 0.223858 2.38672 0.5H2.88672L3.38672 0.5ZM2.88672 94.3868L5.77347 91.5L2.88672 88.6133L-3.26633e-05 91.5L2.88672 94.3868ZM2.88672 0.5H2.38672L2.38672 91.5H2.88672H3.38672L3.38672 0.5L2.88672 0.5Z" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="content">
                                        <h3>Audit & Legacy Evaluation</h3>
                                        <p>We begin by analyzing your existing legacy systems and identifying manual bottlenecks. Our goal is to understand your current touchpoints and map out a strategy for a seamless digital transition.</p>
                                    </div>
                                </li>
                                <li class="single-process">
                                    <div class="step-no"><span>02</span>
                                        <div class="icon">
                                            <svg width="6" height="95" viewBox="0 0 6 95"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M3.38672 0.5C3.38672 0.223858 3.16286 0 2.88672 0C2.61058 0 2.38672 0.223858 2.38672 0.5H2.88672L3.38672 0.5ZM2.88672 94.3868L5.77347 91.5L2.88672 88.6133L-3.26633e-05 91.5L2.88672 94.3868ZM2.88672 0.5H2.38672L2.38672 91.5H2.88672H3.38672L3.38672 0.5L2.88672 0.5Z" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="content">
                                        <h3>Unified Data Integration</h3>
                                        <p>We eliminate silos by connecting your inventory, sales, and customer data into a "Single Source of Truth." This ensures that your pricing and stock levels are consistent across every online and offline channel.</p>
                                    </div>
                                </li>
                                <li class="single-process">
                                    <div class="step-no"><span>03</span>
                                        <div class="icon">
                                            <svg width="6" height="95" viewBox="0 0 6 95"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M3.38672 0.5C3.38672 0.223858 3.16286 0 2.88672 0C2.61058 0 2.38672 0.223858 2.38672 0.5H2.88672L3.38672 0.5ZM2.88672 94.3868L5.77347 91.5L2.88672 88.6133L-3.26633e-05 91.5L2.88672 94.3868ZM2.88672 0.5H2.38672L2.38672 91.5H2.88672H3.38672L3.38672 0.5L2.88672 0.5Z" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="content">
                                        <h3>Personalized Experience Design</h3>
                                        <p>Using data-driven insights, we implement features that allow you to deliver tailored shopping experiences. From personalized recommendations to 24/7 automated service, we help you meet modern shopper demands..
                                        </p>
                                    </div>
                                </li>
                                <li class="single-process">
                                    <div class="step-no"><span>04</span></div>
                                    <div class="content">
                                        <h3>Agile Scale & Optimization</h3>
                                        <p>Once integrated, we focus on continuous improvement. We provide the tools to monitor performance in real-time, allowing your retail business to remain agile and adapt quickly to ever-growing market trends.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
